export const Subtitles = () => {
  const sutitlesObject = [ 
    {
      tmdb_ID: "1050035",
      name: "monstruo",
      videoSrc: "https://mcseguros.com.mx/cineclub/monster.mp4",
      subtitlePath: "/static/subtitles/monster-subs-esp.vtt",
      ciclo: "Orgullo Gay",
      propuestaPor: "Mingo Morales",
    },
    {
      tmdb_ID: "931944",
      name: "el-baño-del-diablo",
      videoSrc: "https://mcseguros.com.mx/cineclub/the-devils-bath.mp4",
      subtitlePath: "/static/subtitles/the-devils-bath-subs-esp.vtt",
      ciclo: "Libre",
      propuestaPor: "Argenis",
    },
    {
      tmdb_ID: "1064486",
      name: "memorias-de-un-caracol",
      videoSrc: "https://mcseguros.com.mx/cineclub/memorias-de-un-caracol.mp4",
      subtitlePath: "/static/subtitles/memorias-de-un-caracol-subs-esp.vtt",
      ciclo: "Oscares",
      propuestaPor: "Cineclub Forever",
    },
    {
      tmdb_ID: "1059128",
      name: "queer",
      videoSrc: "https://mcseguros.com.mx/cineclub/queer-movie.mp4",
      subtitlePath: "/static/subtitles/queer-subs-esp.vtt",
      ciclo: "Libre",
      propuestaPor: "Cineclub Forever",
    },
    {
      tmdb_ID: "1232827",
      name: "la-chica-de-la-aguja",
      videoSrc: "https://mcseguros.com.mx/cineclub/the-girl-with-the-needle.mp4",
      subtitlePath: "/static/subtitles/the-girl-with-the-needle-subs-esp.vtt",
      ciclo: "Libre",
      propuestaPor: "Cineclub Forever",
    },
    {
      tmdb_ID: "1064213",
      name: "anora",
      videoSrc: "https://mcseguros.com.mx/cineclub/anora.mp4",
      subtitlePath: "/static/subtitles/anora-subs-esp.vtt",
      ciclo: "Libre",
      propuestaPor: "Cineclub Forever",
    },
    {
      tmdb_ID: "823219",
      name: "flow",
      videoSrc: "https://mcseguros.com.mx/cineclub/flow-movie.mp4",
      subtitlePath: "/static/subtitles/flow-subs-esp.vtt",
      ciclo: "Libre",
      propuestaPor: "Alma",
    },
    {
      tmdb_ID: "974950",
      name: "emilia-pérez",
      videoSrc: "https://mcseguros.com.mx/cineclub/emilia-perez.mp4",
      subtitlePath: "/static/subtitles/emilia-perez-subs.vtt",
      ciclo: "Libre",
      propuestaPor: "Cineclub Forever",
    },
    {
      tmdb_ID: "23655",
      name: "mundo-rave",
      videoSrc: "https://mcseguros.com.mx/cineclub/groove.mp4",
      subtitlePath: "/static/subtitles/groove-esp.vtt",
      ciclo: "Teens",
      propuestaPor: "Luis Rosales",
    },
    {
      tmdb_ID: "474444",
      name: "les-garçons-sauvages",
      videoSrc: "https://mcseguros.com.mx/cineclub/the-wild-boys.mp4",
      subtitlePath: "/static/subtitles/the-wild-boys-esp.vtt",
      ciclo: "Teens",
      propuestaPor: "Mingo Morales",
    },
  ];

  return sutitlesObject;
};
